<script setup lang="ts">
import type { PropType } from 'vue';

import { type AuctionListingItemEntity, AuctionState } from '~/apiClient';

// PROPS
const { auction } = defineProps({
    auction: { type: Object as PropType<AuctionListingItemEntity>, required: true },
});

// COMPOSABLES
const { tt, tte } = useTypedI18n();

// DATA
const hasCountdown = computed(() => [AuctionState.Pending, AuctionState.Running].includes(auction.state));
</script>

<template>
    <AdpCountdown v-if="hasCountdown" :auction="auction" />
    <p v-else-if="tte(`sdp.Auction.state.${auction.state}`)" class="tracking-wide uppercase">
        {{ tt(`sdp.Auction.state.${auction.state}` as TranslationKey) }}
    </p>
</template>
